<div class="content-max-width back-container" *ngIf="showBackButton">
  <a (click)="continueShopping.emit()" class="back back-btn-rb">All Gift Cards</a>
</div>

<main [ngClass]="isMobileRender ? 'main-mobile' : 'main'">
  <div [ngClass]="isMobileRender ? 'left-mobile' : 'left'">
    <img
      [alt]="giftCard.brand"
      class="card"
      [ngClass]="{ 'card-disabled': !cardAvailability }"
      [class.animate]="animate"
      [src]="giftCard.image"
    />
  </div>

  <div class="right">
    <h1 [ngClass]="{ 'hoyts-giftcard-heading1': isBigWGiftCard }">
      {{ giftCardDisplayName }}
    </h1>

    <div class="cash-back-tag" *ngIf="cashbackPromoTag">
      <span>
        {{ cashbackPromoTag }}
      </span>
    </div>

    <div class="cash-back-tag" *ngIf="plainPromoTag">
      <span>
        {{ plainPromoTag }}
      </span>
    </div>

    <!-- Giftcards Disclaimer -->
    <p
      *ngIf="giftCard.disclaimer"
      id="card-disclaimer"
      class="card-disclaimer-text"
      [innerHTML]="giftCard.disclaimer"
    ></p>

    <div class="value-select">
      <app-select-option
        [dataGiftCard]="giftCard"
        [dataOptions]="giftCard.denominations"
        [titleSelectOption]="titleSelectOption"
      >
      </app-select-option>
    </div>

    <app-buy-for-friend
      (checkoutForFriend)="doCheckoutForFriend()"
      [isCardAvailability]="cardAvailability"
      [isGifEnabled]="isGifEnabled"
      *ngIf="buyType === buyTypeConst.FRIEND"
    ></app-buy-for-friend>

    <ng-template [ngIf]="giftingEnabled">
      <div class="buy-buttons" *ngIf="buyType === ''" style="margin-bottom: 11px; overflow: hidden">
        <button
          [id]="zipYiElement.BuyForFriendButton"
          class="button-small button-gift"
          [ngClass]="[
            !cardAvailability ||
            selectOptionService.dataSelected === '' ||
            !selectOptionService.isValidCustomAmount
              ? 'button-disabled'
              : '',
            crossDomainCssClass
          ]"
          [disabled]="
            !cardAvailability ||
            selectOptionService.dataSelected === '' ||
            !selectOptionService.isValidCustomAmount
          "
          (click)="chooseBuyType(buyTypeConst.FRIEND)"
        >
          <span class="icon-gift"></span>
          {{ buyForFriendLabel }}
        </button>
        <button
          [id]="zipYiElement.BuyForMyselfButton"
          class="button-small button-solid"
          [ngClass]="[
            !cardAvailability ||
            selectOptionService.dataSelected === '' ||
            !selectOptionService.isValidCustomAmount ||
            checkoutStateService.isCheckoutBtnTriggered
              ? 'button-disabled'
              : '',
            crossDomainCssClass
          ]"
          [disabled]="
            !cardAvailability ||
            selectOptionService.dataSelected === '' ||
            !selectOptionService.isValidCustomAmount ||
            checkoutStateService.isCheckoutBtnTriggered
          "
          #submitButton
          (click)="doCheckout()"
        >
          {{ buyForMyselfLabel }}
        </button>
      </div>
    </ng-template>

    <div class="row-btn-checkout transparent-top" *ngIf="!giftingEnabled">
      <button
        [ngClass]="{ 'button-disabled': !cardAvailability }"
        [disabled]="!cardAvailability"
        #submitButton
        (click)="doCheckout()"
      >
        Checkout with
        <span class="icon-impact">
          <img src="assets/impact.svg" />
        </span>
      </button>
    </div>

    <div class="disclaimer" *ngIf="importantContent">
      <div>
        <div class="disclaimer-text" #disclaimerText [innerHTML]="importantContentTruncate"></div>
        <span class="blue-link seemore-link" (click)="showMore()" *ngIf="isLongDesc && !isSeeMore"
          >See more</span
        >
        <span class="blue-link seeless-link" (click)="showLess()" *ngIf="isLongDesc && isSeeMore"
          >See less</span
        >
      </div>
    </div>

    <div class="cashback-disclaimer" *ngIf="showCashBackDisclaimer">
      <span>Cashback with Zip Money</span>
      <span class="cashback-disclaimer-text">
        Purchase any denomination of the '{{ giftCard.brand }}' gift card and earn
        {{ cashbackPercentage }} of the value of your Gift card as cashback when you checkout with
        Zip Money. Cashback will be added to your Zip rewards balance.
      </span>
    </div>

    <div
      class="terms-container"
      [class.closed]="!showProductFeatures"
      [class.open]="showProductFeatures"
      *ngIf="isAmazonGiftCard"
    >
      <div class="terms-dropdown" (click)="showProductFeatures = !showProductFeatures">
        Product features <span><img src="assets/dropdown-terms.svg" /></span>
      </div>
      <ul class="product-features">
        <li>
          Amazon.com.au Gift Cards carry no additional fees and expire 10 years from the date of
          issuance.
        </li>
        <li>Redeemable towards millions of items store-wide at Amazon.com.au.</li>
      </ul>
    </div>

    <div class="terms-container" [class.closed]="!showDelivery" [class.open]="showDelivery">
      <div class="terms-dropdown" (click)="showDelivery = !showDelivery">
        Delivery <span><img src="assets/dropdown-terms.svg" /></span>
      </div>
      <div class="disclaimer">
        <p>
          <strong> When buying for a friend: </strong>
          <br />
          A digital gift card will be delivered to your friend’s email address. Please check the
          email address you enter carefully, as gift cards are non-refundable. As soon as you see
          the confirmation after checkout, your gift card will be on its way to your friend’s inbox!
        </p>
        <p>
          <strong> When buying for yourself: </strong>
          <br />
          A digital gift card will be delivered to the email address associated with your Zip
          account, please check your email address is correct and valid before purchasing, as gift
          cards are non-refundable.
        </p>
      </div>
    </div>

    <div class="terms-container" [class.closed]="!showDisclaimer" [class.open]="showDisclaimer">
      <div class="terms-dropdown" (click)="showDisclaimer = !showDisclaimer">
        Terms & Conditions <span><img src="assets/dropdown-terms.svg" /></span>
      </div>
      <div class="disclaimer">
        <div *ngIf="giftCard.terms && !isAmazonGiftCard">
          <p [innerHTML]="giftCard.terms"></p>
        </div>

        <div *ngIf="isAmazonGiftCard">
          <p>
            Amazon.com.au gift cards can be used only for the purchase of eligible goods on
            Amazon.com.au. For complete terms and conditions, see
            <a href="https://www.amazon.com.au/gc-legal" target="_blank"
              >www.amazon.com.au/gc-legal</a
            >
          </p>
        </div>
      </div>

      <ul class="terms-link-container">
        <li class="terms-link">
          <a href="https://zip.co/gift-cards-terms-and-conditions" target="_blank"
            >See Zip Gift Card Terms and Conditions</a
          >
        </li>
        <li *ngIf="giftCard.termsLink" class="terms-link">
          <a target="_blank" [attr.href]="giftCard.termsLink">Terms and Conditions.</a>
        </li>
      </ul>
    </div>

    <p>
      Gift cards are <strong>non-refundable</strong>. By purchasing you agree to the Terms and
      Conditions.
    </p>

    <a
      *ngIf="buyType === '' && !isMobileRender"
      class="continue-shopping"
      (click)="continueShopping.emit()"
      href="javascript:void(0)"
    >
      <img src="assets/arrow--left.svg" />
      Continue Shopping
    </a>

    <a
      *ngIf="buyType !== '' && !isMobileRender"
      href="javascript:void(0)"
      class="continue-shopping"
      (click)="chooseBuyType('')"
    >
      <img src="assets/arrow--left.svg" />
      Back
    </a>

    <div *ngIf="!isMobileRender" class="browse-giftcards">
      <h2 class="browse-title">Browse gift cards</h2>

      <div class="short-list" *ngIf="browseCards?.length">
        <div class="browse-item" *ngFor="let card of browseCards">
          <img [src]="card.image" (click)="browseClick.emit(card)" />
        </div>
      </div>
    </div>
  </div>
  <!--  <div class="spacing-for-help"></div>-->
</main>
